module.exports = __webpack_public_path__ + "img/WALK-PERFORMANCE-A-GAUCHE.22494b59.svg";